export default 
{
  type: "form-submit-button",
  style: "",
  data: {
    label: "Submit",
    action: "submit",
    submitedAction: "redirectUrl",
    submitedRedirectUrl: "",
    placeholder: "",
    backgroundColor: { r: 0, g: 0, b: 0, a: 1 },
    labelColor: { r: 255, g: 255, b: 255, a: 1 },
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 24,
    paddingRight: 24,
    autoWidth: true,
  },
  children: [],
};
